import { useSuspenseQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'

import { enterpriseMembership } from '../queries/enterprise'
import type { EnterpriseInvitationStatus, EnterpriseRole, EnterpriseType } from '../schemas/enterprise'

export type EnterpriseInvitationResponse = {
  id: number
  enterpriseId: number
  inviterName: string
  inviterId: number
  inviteeId: number | null
  status: EnterpriseInvitationStatus
  email: string
  role: EnterpriseRole
  createdAt: string
  updatedAt: string | null
  enterpriseType: EnterpriseType
  enterpriseName: string
  enterpriseLogoPicture: string
}

export type GetEnterpriseInvitationParams = {
  invitationId: number | string
}

const getEnterpriseInvitationById = async ({ invitationId }: GetEnterpriseInvitationParams) => {
  try {
    const response = await getRequest<EnterpriseInvitationResponse>(`/enterprise/invitations/${invitationId}`)

    if (!response) return null

    return response
  } catch (error) {
    console.error('Error getting enterprise invitation by id', error)
    return null
  }
}

export const useEnterpriseInvitationById = (invitationId: number | string) => {
  return useSuspenseQuery({
    ...enterpriseMembership.invitationById(invitationId),
    queryFn: () => getEnterpriseInvitationById({ invitationId }) as Promise<EnterpriseInvitationResponse>,
  })
}
